/* eslint-disable no-unused-vars */
import {React,useState} from "react";
import { FacebookShareButton, FacebookIcon, TwitterShareButton, 
TwitterIcon, WhatsappShareButton, WhatsappIcon,
LinkedinShareButton, LinkedinIcon,EmailShareButton, EmailIcon,
  } from 'react-share';
import { FaYoutube, FaInstagram  } from 'react-icons/fa';
import LoadingButton from '@mui/lab/LoadingButton';
import { useStyles } from './SelfService';
import CallIcon from '@mui/icons-material/Call';
import {
    Typography,Grid,
    Button,
    IconButton,
    TextField,
    Checkbox,
    Box,
    colors,
    Dialog,
    DialogActions,
    DialogContent,
    CardActions,
    List, ListItem, ListItemText, ListItemAvatar, Avatar,Card,CardHeader, CardActionArea, CardContent
} from "@material-ui/core";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import '../../App.css';
import BacktoTop from "./BacktoTop";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, InputGroup, Row,Container,Col} from 'react-bootstrap';
import Axios from 'axios';
const makeCall=(phoneNumber)=>{
    window.location.href = `tel:${phoneNumber}`;
}

const Channels=()=>{
    const phoneNumber = '+256800217200';
    const QrCodeDialog=()=>{
        const [open, setOpen] = useState(false);

        const handleClose = () => {
         setPreviewOpen(false);
        };

       const previewDialogClick=()=>{
       setPreviewOpen(true); 
       }
       const [previewOpen, setPreviewOpen] = useState(false);
       return(
        <div>
        <Dialog
          fullScreen={false}
          open={previewOpen}
          onClose={handleClose}
        >
            <DialogContent>
                <p>Scan the QR CODE Below to Rate our Services</p>
                <img src={require('../../assets/qrcode.png')} alt="QRCODE" style={{ width: 350, height: 250 }} ></img>
            </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} href="https://forms.office.com/r/LDbVFerYG1" target="_blank" >Rate us Via Link</Button>
          <LoadingButton type="submit"
          onClick={handleClose}
          variant="outlined"
          >Close QRCODE</LoadingButton>
          </DialogActions>
        </Dialog>
        
        <QrCodeScannerIcon sx={{ color: "white", backgroundColor: "#000000",height: "40px", width: "40px"}} type="button" onClick={previewDialogClick}/>
        </div>       
       )

    }
      //Handling the click count on the different social media option

    //Saving the count to storage 
    const [clickCount, setClickCount] = useState(() => {
        const countFromStorage = localStorage.getItem('clickCount');
        return countFromStorage ? parseInt(countFromStorage, 10) : 0;
    });
    function handleComponentClick() {
        setClickCount(prevCount => prevCount + 1);
        console.log(clickCount);
        Axios.post('/api/clicks', { count: clickCount + 1 })
        .then(response => {
            // Handle successful response if needed
        })
        .catch(error => {
            // Handle error if needed
        });
    }
    return(
        <Grid container alignItems="center" justifyContent="center">
        <Grid>
        <Avatar>
            <TwitterShareButton url={'https://twitter.com/postbankug?s=09'}  hashtag="#muo"><TwitterIcon size={60} round />
            </TwitterShareButton>
        </Avatar>
        </Grid>
        &nbsp;&nbsp;
        <Grid>
        <Avatar>
            <FacebookShareButton url={'https://m.facebook.com/Postbank.Uganda/posts/'}  hashtag="#muo">
              <FacebookIcon size={60} round />
            </FacebookShareButton>
        </Avatar>
        </Grid>
        &nbsp;&nbsp;
        <Grid>
        <Avatar>
            <WhatsappShareButton url={'https://chatwith.io/s/postbank-uganda'}  hashtag="#muo"><WhatsappIcon size={50} round />
            </WhatsappShareButton>
        </Avatar>
        </Grid>
        &nbsp;&nbsp;
        <Grid>
        <Avatar>
            <LinkedinShareButton url={'https://m.facebook.com/Postbank.Uganda/posts/'}  hashtag="#muo">
              <LinkedinIcon size={60} round />
            </LinkedinShareButton>
        </Avatar>
        </Grid>
        &nbsp;&nbsp;
        <Grid>
        <Avatar>
            <EmailShareButton url="customerservice@postbank.co.ug">
                <EmailIcon size={50} />
            </EmailShareButton> 
        </Avatar>
        </Grid>
        &nbsp;&nbsp;
        <Grid>
        <Avatar>
            <CallIcon onClick={() => makeCall(phoneNumber)}/>
        </Avatar>
        </Grid>
        &nbsp;&nbsp;
        <Grid>
            <Avatar>
            <a
                href="https://www.youtube.com/channel/UCeOKbsR9pZXsvSd3Tbkm66A"
                target="_blank"
                rel="noopener noreferrer"
            >
            <FaYoutube size={60} color="#FF0000" />
            </a>
            </Avatar>
        </Grid>
        &nbsp;&nbsp;
        {/*<Grid>
        <Avatar>
            <a
                href="https://www.instagram.com/your_instagram_username/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FaInstagram size={60} />
            </a>
        </Avatar>
    </Grid>*/}
        &nbsp;&nbsp;
        <Grid>            
        <QrCodeDialog/>
        </Grid>
        </Grid>
        
        
    )
}

const Footer=()=>{
    const classes =  useStyles();
 return(
    <Box my={2} className={classes.card}><br/>
        <Channels/><br></br>        
        <Typography align="center">
        Customer Deposits are protected by the Deposit Protection Fund of Uganda. PostBank is regulated by the Central Bank of Uganda.
        </Typography>
    </Box>
 )
}
export default Footer